import { RNWebView } from '../../Types'

interface MessageToReactNative {
  [key: string]: unknown
  type: string
}

/**
 * Sends message to react native. The type is used to define specific action on react native side.
 * Note that if you use this function you likely want to change react-native code, which needs be deployed/released separately.
 *
 * @param message
 */
export const sendMessageToReactNative = (message: MessageToReactNative): void => {
  const WebViewWindow = window as unknown as RNWebView

  WebViewWindow?.ReactNativeWebView?.postMessage(JSON.stringify(message))
}

interface SendEmailFromReactNativeProps {
  subject?: string
  recipient: string
  body?: string
}

/**
 * Function to send a message to react native to open a default mail app with a new prefilled email
 */
export const sendEmailFromReactNative = ({ body = '', subject = '', recipient }: SendEmailFromReactNativeProps): void => {
  sendMessageToReactNative({ type: 'email', body, recipient, subject })
}

/**
 * Function to send a message to react native to open the app rating dialog or browser depending on the availability
 */
export const rateAppFromReactNative = (): void => {
  sendMessageToReactNative({ type: 'rate-app' })
}
